import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Loading } from '../shared/Loading';
import { LoadingFailed } from '../shared/LoadingFailed';
import { PageLayout } from '../shared/PageLayout';

const Resort = React.lazy(() => import('./Resort'));

const ResortLoadingFailed: React.FC = () => {
  const { t } = useTranslation('translation');
  return (
    <PageLayout title={t('resort')} color="#f1ccd0" backLabel={t('aria_button_back_to_previous')}>
      <LoadingFailed error="unstable-network" />
    </PageLayout>
  );
};

const ResortLoading: React.FC = () => {
  const { t } = useTranslation('translation');
  return (
    <PageLayout
      title={t('resort')}
      color="#f1ccd0"
      background="transparent"
      backLabel={t('aria_button_back_to_previous')}
    >
      <Loading color="#aea681" />
    </PageLayout>
  );
};

export default class extends React.Component<Record<string, unknown>, { hasError?: boolean }> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }
  public static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }
  public render() {
    if (this.state.hasError) {
      return <ResortLoadingFailed />;
    } else {
      return (
        <Suspense fallback={<ResortLoading />}>
          <Resort />
        </Suspense>
      );
    }
  }
}
